// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : GOLD CLOSE LOAN SAGA CREATED
// MODIFIED DATE: 23-08-2025

import { call, put, takeLatest, all } from 'redux-saga/effects';
import GoldCloseLoanActionTypes from './gold-close-loan.types';
import {
	getGoldLoanMemberDetailsSuccess,
	getGoldLoanMemberDetailsFailure,
	getGoldLoanMemberDetailsResponseChanged,
	updateGoldCloseDetailsSuccess,
	updateGoldCloseDetailsFailure,
	updateGoldCloseDetailsResponseChanged,
} from './gold-close-loan.action';
import { getGoldLoanMemberDetails, updateGoldCloseDetails } from './gold-close-loan.service';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** ********************* GET GOLD LOAN MEMBER DETAILS START ******************** */
export function* getGoldLoanMemberDetailsSaga({ payload }: any) {
	try {
		const { companyID, userID, branchID, centerID, groupID, databaseName, closeDate } = payload;
		const key = 'GetGoldLoanMemberDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			DatabaseName: databaseName,
			CloseDate: closeDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getGoldLoanMemberDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldLoanMemberDetailsFailure(responseData.data));
		} else {
			yield put(getGoldLoanMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldLoanMemberDetailsFailure(error));
	}
}

export function* resetGetGoldLoanMemberDetailsResponse() {
	yield put(getGoldLoanMemberDetailsResponseChanged());
}

export function* onGetGoldLoanMemberDetails() {
	yield takeLatest(
		GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_START,
		getGoldLoanMemberDetailsSaga,
	);
}

export function* onGetGoldLoanMemberDetailsResponseReset() {
	yield takeLatest(
		GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_RESPONSE_RESET,
		resetGetGoldLoanMemberDetailsResponse,
	);
}
/** ********************* GET GOLD LOAN MEMBER DETAILS END ******************** */

/** ********************* UPDATE GOLD CLOSE DETAILS START ******************** */
export function* updateGoldCloseDetailsSaga({ payload }: any) {
	try {
		const key = 'UpdateGoldCloseDetailsKey';
		const {
			companyID,
			userID,
			userName,
			userAccessBranchID,
			userLevel,
			infogCompanyID,
			branchID,
			centerID,
			groupID,
			databaseName,
			closeDate,
			closeMemberList,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			UserLevel: userLevel,
			InfogID: infogCompanyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			DatabaseName: databaseName,
			CloseDate: closeDate,
			CloseMemberList: JSON.stringify(closeMemberList),
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateGoldCloseDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateGoldCloseDetailsFailure(responseData.data));
		} else {
			yield put(updateGoldCloseDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateGoldCloseDetailsFailure(error));
	}
}

export function* resetUpdateGoldCloseDetailsResponse() {
	yield put(updateGoldCloseDetailsResponseChanged());
}

export function* onUpdateGoldCloseDetails() {
	yield takeLatest(
		GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_START,
		updateGoldCloseDetailsSaga,
	);
}

export function* onUpdateGoldCloseDetailsResponseReset() {
	yield takeLatest(
		GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_RESPONSE_RESET,
		resetUpdateGoldCloseDetailsResponse,
	);
}
/** ********************* UPDATE GOLD CLOSE DETAILS END ******************** */

export function* GoldCloseLoanSaga() {
	yield all([
		call(onGetGoldLoanMemberDetails),
		call(onGetGoldLoanMemberDetailsResponseReset),
		call(onUpdateGoldCloseDetails),
		call(onUpdateGoldCloseDetailsResponseReset),
	]);
}
